import React, { useState, useEffect } from 'react';

function LinkList(props) {
	return (
		props.data &&
		<React.Fragment>
			{
				props.children
			}
			<table className="table">
				<tbody>
					{
						props.data.map((item, index) => <tr key={index}><td><a href={item.url}>{item.name}</a></td></tr>)
					}
				</tbody>
			</table>
		</React.Fragment>
	)
}

export default LinkList;
